import React, { useState, useEffect } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import { observer } from 'mobx-react';
import mainRoutes from 'routes/mainRoutes';
import AuthContainer from 'containers/AuthContainer';
import UserLayout from 'layouts/UserLayout';
import AdminLayout from 'layouts/AdminLayout';
import ManagementLayout from 'layouts/ManagementLayout';
import styled, { keyframes } from 'styled-components';

const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

const LayoutWrapper = observer(() => {
  const location = useLocation();
  const [displayOverlay, setDisplayOverlay] = useState(false);

  const getLayout = (element: JSX.Element) => {
    if (window.location.pathname.includes('/admin')) {
      return <AdminLayout>{element}</AdminLayout>;
    } else if (window.location.pathname.includes('/management')) {
      return <ManagementLayout>{element}</ManagementLayout>;
    } else {
      return <UserLayout>{element}</UserLayout>;
    }
  };

  // 페이지 변경 감지
  useEffect(() => {
    // 페이지 변경 시 오버레이 표시
    setDisplayOverlay(true);

    // 오버레이 제거 타이머
    const timer = setTimeout(() => {
      setDisplayOverlay(false);
    }, 500);

    return () => clearTimeout(timer);
  }, [location.key]); // location.key를 사용하여 모든 위치 변경 감지

  return (
    <Container>
      {/* {displayOverlay && <Overlay />} */}

      {/* <PageContent show={!displayOverlay}> */}
      <Routes>
        {mainRoutes.map((route, index: number) => {
          return (
            <Route
              key={index}
              path={route.path}
              element={
                <AuthContainer isPublic={route.isPublic} title={route.name}>
                  {getLayout(<route.element />)}
                </AuthContainer>
              }
            />
          );
        })}
      </Routes>
      {/* </PageContent> */}
    </Container>
  );
});

const Container = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`;

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: white;
  z-index: 9999;
`;

const PageContent = styled.div<{ show: boolean }>`
  opacity: ${(props) => (props.show ? 1 : 0)};
  animation: ${(props) => (props.show ? fadeIn : 'none')} 500ms ease forwards;
  width: 100%;
  height: 100%;
`;

export default LayoutWrapper;
